import { Stack, Typography } from '@mui/material';

import LinkIcon from '@/components/Icons/LinkIcon';
import { usePinnedAPI } from '@/sections/Overview/Chains/hooks';
import VersionsCountByStatus from '@/sections/Workspace/VersionsCountByStatus';
import {
  colorForStatus,
  getEntityDeploymentsCount,
  getVersionsByStatus,
  sortVersionsByStatus,
} from '@/sections/Workspace/utils';
import { ColorScale } from '@/theme/colors';

import {
  CardNameContainer,
  IconContainer,
  ModelData,
  StatusColor,
  StatusColors,
  StatusContainer,
} from '../../styled';
import Actions from '../Actions';
import { CardProps } from './types';

function Chain({ chain }: CardProps) {
  const versionsByStatus = sortVersionsByStatus(getVersionsByStatus(chain.deploymentCountByStatus));
  const totalCount = getEntityDeploymentsCount(chain);
  const { getPinActionItem } = usePinnedAPI();

  return (
    <ModelData>
      <Stack gap={1.5} pt={2} pb={2.5} pl={2.5} pr={2} flex={1}>
        <Stack spacing={0.5}>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <CardNameContainer>
              <IconContainer>
                <LinkIcon
                  sx={{
                    color: ColorScale.purple[700],
                  }}
                />
              </IconContainer>
              <Typography
                variant="h4"
                sx={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
              >
                {chain.name}
              </Typography>
            </CardNameContainer>
            <Stack direction="row" gap={0.2}>
              {getPinActionItem(chain.id, chain.name)}
              <Actions chainId={chain.id} chainName={chain.name} variant="minimal" />
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      <StatusContainer>
        <VersionsCountByStatus options={versionsByStatus} />
      </StatusContainer>
      <StatusColors>
        {versionsByStatus
          .filter(([, count]) => count)
          .map(([status, count]) => (
            <StatusColor
              key={status}
              sx={{
                width: `${(count / totalCount) * 100}%`,
                backgroundColor: colorForStatus[status],
              }}
            />
          ))}
      </StatusColors>
    </ModelData>
  );
}

export default Chain;
